import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export const SsoTestModeBanner = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sso-test-mode-banner" */ './hocs')),
});
